import * as React from 'react'

import {IconProps} from '.'

function Copy({color, size}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      {/* Back document */}
      <path
        d="M5.625 4.125H10.125C10.7463 4.125 11.25 4.62868 11.25 5.25V9.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Front document */}
      <path
        d="M4.875 5.625H9.375C9.99632 5.625 10.5 6.12868 10.5 6.75V11.25C10.5 11.8713 9.99632 12.375 9.375 12.375H4.875C4.25368 12.375 3.75 11.8713 3.75 11.25V6.75C3.75 6.12868 4.25368 5.625 4.875 5.625Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export default Copy
